import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import CarrierDTO from '../../../../dto/CarrierDTO';
import FileInput from '../../../../components/fields/FileInput/FileInput';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';
import { szltHelper } from '../../../RegionRegistry/actions';
import { required } from '../../../../utils/validation';
import CustomRegistryNumberSelector from '../../../../components/fields/SelectInput/CustomRegistryNumberSelector';

export default function CarrierSZLTForm(props) {
  const {
    prefix = '', labelPrefix = '', disabled = false, control, index, legalEntityType, procedure,
  } = props;

  const DTO = new CarrierDTO({ legal_entity_type: legalEntityType, procedure });
  const attributes = DTO.getAttributesByName();

  return (
    <>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          type="text"
          component={CustomRegistryNumberSelector}
          dtoObject={{
            ...attributes.number,
            name: `order_services_attach.${index}.order_service_number`,
            validators: [required],
            labelKey: 'order_service_number',
          }}
          variant="material"
          namePrefix={prefix}
          labelPrefix={labelPrefix}
          disabled={disabled}
          withLabel
          loadAction={szltHelper}
          // options={szltList.map(i => ({ value: i.number, name: i.number }))}
        />
      </Row>
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          type="text"
          component={TextInputWithLabel}
          dtoObject={{
            ...attributes.order_service_contract_number,
            name: `order_services_attach.${index}.contract_number`,
          }}
          variant="material"
          namePrefix={prefix}
          labelPrefix={labelPrefix}
          disabled={disabled}
        />
        <FieldDTOWithCol
          control={control}
          type="text"
          component={DateTimePicker}
          hideTime
          changeFormat="YYYY-MM-DD"
          dtoObject={{
            ...attributes.order_service_contract_effective_date,
            name: `order_services_attach.${index}.contract_effective_date`,
          }}
          variant="material"
          namePrefix={prefix}
          labelPrefix={labelPrefix}
          disabled={disabled}
          withLabel
        />
      </Row>
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          type="text"
          component={DateTimePicker}
          hideTime
          changeFormat="YYYY-MM-DD"
          dtoObject={{
            ...attributes.order_service_contract_expiration_date,
            name: `order_services_attach.${index}.contract_expiration_date`,
          }}
          variant="material"
          namePrefix={prefix}
          labelPrefix={labelPrefix}
          disabled={disabled}
          withLabel
        />
        <FieldDTOWithCol
          control={control}
          type="text"
          component={FileInput}
          dtoObject={{
            ...attributes.order_service_contract_files,
            name: `order_services_attach.${index}.order_service_contract_files`,
          }}
          variant="material"
          namePrefix={prefix}
          labelPrefix={labelPrefix}
          disabled={disabled}
          withLabel
          multiple
        />
      </Row>
    </>
  );
}
